<template>
  <div class="quick-info-section">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'QuickInfoSection',
};

</script>


<style scoped>
.quick-info-section {
  background: #DDD;
  margin: -18px -18px 18px;
  padding: 18px;
}
</style>
